/**
 * The Math — Ledger (The Books) for torque.coffee/pages/the-math
 * Vanilla JS, no dependencies.
 * Renders all ledger rows from a JSON blob, with Year + Origin filters and sortable columns.
 * Origin's share and % are both derived from a single green-pounds factor so they always agree.
 */

(function () {
  'use strict';

  // Green coffee lbs per 12oz/340g bag, ~15% roast shrinkage: 12/16/0.85
  var GREEN_LBS = (12 / 16) / 0.85;

  var rows = [];
  var filterYear = 'recent';   // 'recent' (current + last year) or 'all'
  var filterCountry = 'all';
  var sortKey = 'name';
  var sortDir = 1;             // 1 asc, -1 desc

  var bodyEl, countryEl, yearEl, countEl, tableEl;

  function fmt(n) { return '$' + Number(n).toFixed(2); }
  function pct(n) { return Number(n).toFixed(1) + '%'; }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function loadData() {
    var el = document.getElementById('the-math-ledger-data');
    if (!el) return;
    var parsed;
    try { parsed = JSON.parse(el.textContent); }
    catch (e) { parsed = []; }

    rows = parsed.map(function (r) {
      var fob = Number(r.fob);
      var retail = Number(r.retail);
      var kept = (retail > 0) ? fob * GREEN_LBS : 0;
      var pctVal = (retail > 0) ? (kept / retail) * 100 : 0;
      return {
        name: r.name || '',
        origin: r.origin || '',
        year: String(r.year || ''),
        yearNum: parseInt(r.year, 10) || 0,
        fob: fob,
        retail: retail,
        kept: kept,
        pct: pctVal
      };
    });
  }

  function currentYear() {
    return new Date().getFullYear();
  }

  function populateCountryFilter() {
    if (!countryEl) return;
    var seen = {};
    var list = [];
    for (var i = 0; i < rows.length; i++) {
      var c = rows[i].origin;
      if (c && !seen[c]) { seen[c] = true; list.push(c); }
    }
    list.sort();
    for (var j = 0; j < list.length; j++) {
      var opt = document.createElement('option');
      opt.value = list[j];
      opt.textContent = list[j];
      countryEl.appendChild(opt);
    }
  }

  function getFiltered() {
    var cy = currentYear();
    return rows.filter(function (r) {
      if (filterYear === 'recent') {
        if (r.yearNum !== cy && r.yearNum !== cy - 1) return false;
      }
      if (filterCountry !== 'all' && r.origin !== filterCountry) return false;
      return true;
    });
  }

  function sortRows(list) {
    var k = sortKey, dir = sortDir;
    return list.slice().sort(function (a, b) {
      var av, bv;
      if (k === 'name')        { av = a.name.toLowerCase();   bv = b.name.toLowerCase(); }
      else if (k === 'origin') { av = a.origin.toLowerCase(); bv = b.origin.toLowerCase(); }
      else if (k === 'year')   { av = a.yearNum;  bv = b.yearNum; }
      else if (k === 'fob')    { av = a.fob;      bv = b.fob; }
      else if (k === 'retail') { av = a.retail;   bv = b.retail; }
      else if (k === 'kept')   { av = a.kept;     bv = b.kept; }
      else if (k === 'pct')    { av = a.pct;      bv = b.pct; }
      else                     { av = a.name.toLowerCase(); bv = b.name.toLowerCase(); }
      if (av < bv) return -1 * dir;
      if (av > bv) return 1 * dir;
      // tiebreak by name asc for stable feel
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
  }

  function render() {
    if (!bodyEl) return;
    var list = sortRows(getFiltered());

    if (list.length === 0) {
      bodyEl.innerHTML = '<tr><td colspan="7" class="the-math-empty" style="padding:3rem;">No coffees match these filters.</td></tr>';
    } else {
      var html = '';
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        html +=
          '<tr>' +
            '<td>' + escHtml(r.name) + '</td>' +
            '<td>' + escHtml(r.origin) + '</td>' +
            '<td class="text-right mono">' + escHtml(r.year) + '</td>' +
            '<td class="text-right mono">' + fmt(r.fob) + '</td>' +
            '<td class="text-right mono">' + fmt(r.retail) + '</td>' +
            '<td class="text-right mono highlight">' + fmt(r.kept) + '</td>' +
            '<td class="text-right mono highlight">' + pct(r.pct) + '</td>' +
          '</tr>';
      }
      bodyEl.innerHTML = html;
    }

    if (countEl) {
      countEl.textContent = list.length + (list.length === 1 ? ' coffee' : ' coffees');
    }

    updateSortIndicators();
  }

  function updateSortIndicators() {
    if (!tableEl) return;
    var ths = tableEl.querySelectorAll('th.the-math-sortable');
    for (var i = 0; i < ths.length; i++) {
      var th = ths[i];
      var arrow = th.querySelector('.the-math-sort-arrow');
      if (th.getAttribute('data-sort') === sortKey) {
        th.classList.add('the-math-sorted');
        if (arrow) arrow.innerHTML = sortDir === 1 ? ' &#9650;' : ' &#9660;';
      } else {
        th.classList.remove('the-math-sorted');
        if (arrow) arrow.innerHTML = '';
      }
    }
  }

  function onSortClick(key) {
    if (sortKey === key) {
      sortDir = -sortDir;
    } else {
      sortKey = key;
      sortDir = 1;
    }
    render();
  }

  var TheMathLedger = {
    onFilterChange: function () {
      if (yearEl) filterYear = yearEl.value;
      if (countryEl) filterCountry = countryEl.value;
      render();
    }
  };

  function init() {
    bodyEl = document.getElementById('the-math-ledger-body');
    countryEl = document.getElementById('the-math-ledger-country');
    yearEl = document.getElementById('the-math-ledger-year');
    countEl = document.getElementById('the-math-ledger-count');
    tableEl = document.getElementById('the-math-ledger-table');
    if (!bodyEl) return;

    loadData();
    populateCountryFilter();

    if (tableEl) {
      var ths = tableEl.querySelectorAll('th.the-math-sortable');
      for (var i = 0; i < ths.length; i++) {
        (function (th) {
          th.addEventListener('click', function () {
            onSortClick(th.getAttribute('data-sort'));
          });
        })(ths[i]);
      }
    }

    render();
  }

  window.TheMathLedger = TheMathLedger;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
